import type { HighRiskMerchant as HighRiskMerchantType } from "features/ecommerce/types";
import { HighRiskMerchant } from "ui/forms/ECommerce";
import { useOnboardingStepData } from "ui/organizms/ECommerce/Onboarding/common";

export const useMarketingWebsiteAndSupport = () => {
    const { data } = useOnboardingStepData<HighRiskMerchantType.OnboardingMarketingWebsiteAndSupport>();

    const formProps: HighRiskMerchant.MarketingWebsiteAndSupport.OnboardingMarketingWebsiteAndSupportForm = {
        bootstrapData: {},
        initialValues: HighRiskMerchant.MarketingWebsiteAndSupport.getInitialValues(data),
        isBootstrapDataLoading: false,
        onSaveOrCreate: () => {
            alert('Not implemented yet please wait for the update.');
        }
    };

    return {
        ...formProps,
        ...HighRiskMerchant.MarketingWebsiteAndSupport.useForm(formProps),
        ...data
    };
};

export default useMarketingWebsiteAndSupport;
